import { createContext } from 'react';
import { ABTestContextValue } from '~/types';

export const ABTestContext = createContext<ABTestContextValue | undefined>(undefined);
